import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTab,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

const SURQUAL_BOOKING_STATUS_PAGE_BOOKING_STATUS_TAB: ConfigurationPageTables =
  {
    description: "CONF_DESC_SELFMAPPING_RESA_STATUS",
    type: ConfigurationPageType.TABLE,
    path: "test",
    label: "RESERVATION_STATUS",
    model: {
      entityName: "short_name",
      label: "RESERVATION_STATUS",
      path: "/api/booking-statuses",
      bulkPath: "/api/booking-statuses/bulk-updates",
      name: "Statut réservation",
      attributes: [
        {
          className: "greyText",
          key: "code",
          order: 1,
          label: "CODE",
          visible: true,
        },
        {
          key: "short_name",
          order: 2,
          label: "SHORT_NAME",
          visible: true,
        },
        {
          className: "greyText separationColumnRight",
          headerClassName: "separationColumnRight",
          key: "name",
          order: 3,
          label: "LONG_NAME",
          visible: true,
        },
        {
          key: "nb_uh_r12",
          className: "progressOcc",
          order: 4,
          label: "OCC_SOLD",
          sortingOrder: ["desc", "asc", null],
          type: FormatType.PROGRESS,
          visible: true,
        },
        {
          key: "turnover_r12",
          className: "progressCA",
          order: 5,
          label: "CA_SOLD",
          sortingOrder: ["desc", "asc", null],
          type: FormatType.PROGRESS_CURRENCY,
          visible: true,
        },
        {
          key: "pm_r12",
          className: "progressPM",
          order: 6,
          label: "PM_SOLD",
          sortingOrder: ["desc", "asc", null],
          type: FormatType.PROGRESS_CURRENCY,
          visible: true,
        },
        {
          key: "group1.short_name",
          order: 7,
          label: "GROUP_1",
          visible: true,
        },
        {
          key: "booking_status_nandc.short_name",
          order: 8,
          label: "N&C",
          visible: true,
        },
      ],
      filters: [
        {
          type: ConfigurationTableFilterType.Unmapped,
          api: "/api/booking-statuses/?is_unmapped=1",
        },
        {
          type: ConfigurationTableFilterType.Search,
        },
        {
          type: ConfigurationTableFilterType.ResetButton,
        },
      ],
      export: { path: "/api/booking-statuses/export" },
      import: { path: "/api/booking-statuses/presign-url" },
    },
    options: {
      formFields: [
        {
          key: "code",
          label: "CODE",
          type: ConfigurationFormType.Input,
        },
        {
          key: "short_name",
          label: "SHORT_NAME",
          type: ConfigurationFormType.Input,
        },
        {
          key: "name",
          label: "LONG_NAME",
          type: ConfigurationFormType.Input,
        },
        {
          type: ConfigurationFormType.Select,
          api: "/api/booking-status-groups-1/",
          apiParams: {
            page_size: 100,
            ordering: "short_name",
          },
          column: "short_name",
          key: "group1",
          label: "GROUP_1",
          labelKey: "short_name",
        },
        {
          type: ConfigurationFormType.Select,
          api: "/api/booking-statuses-nandc/",
          apiParams: {
            page_size: 100,
            ordering: "short_name",
          },
          column: "booking_status_nandc.short_name",
          key: "booking_status_nandc",
          label: "N&C",
          labelKey: "short_name",
        },
        {
          key: "separatorQualification",
          label: "QUALIFICATION",
          type: ConfigurationFormType.Separator,
        },
      ],
      copyable: false,
      creatable: true,
      createOptions: [
        {
          key: "code",
          flex: "50%",
          required: true,
        },
        {
          key: "short_name",
          flex: "50%",
          required: true,
        },
        {
          key: "name",
          flex: "100%",
          required: true,
        },
        {
          key: "separatorQualification",
          flex: "100%",
        },
        {
          key: "booking_status_nandc",
          flex: "50%",
        },
        {
          key: "group1",
          flex: "50%",
        },
      ],
      deletable: true,
      editable: true,
      editOptions: [
        {
          key: "code",
          flex: "50%",
          required: true,
        },
        {
          key: "short_name",
          flex: "50%",
          required: true,
        },
        {
          key: "name",
          flex: "100%",
          required: true,
        },
        {
          key: "separatorQualification",
          flex: "100%",
        },
        {
          key: "group1",
          flex: "50%",
        },
        {
          key: "booking_status_nandc",
          flex: "50%",
        },
      ],
      editSelectedOptions: [
        {
          key: "group1",
          flex: "50%",
        },
        {
          key: "booking_status_nandc",
          flex: "50%",
        },
      ],
    },
  };

const SURQUAL_BOOKING_STATUS_PAGE_BOOKING_STATUS_GROUP_TAB: ConfigurationPageTables =
  {
    description: "CONF_PAGE_DESC_DEFAULT",
    type: ConfigurationPageType.TABLE,
    path: "test",
    label: "RESERVATION_STATUS_GROUP_1",
    model: {
      entityName: "short_name",
      label: "RESERVATION_STATUS_GROUP_1",
      path: "/api/booking-status-groups-1",
      name: "Statut Réservation Groupe1",
      attributes: [
        {
          className: "greyText",
          key: "code",
          order: 1,
          label: "CODE",
          visible: true,
        },
        {
          key: "short_name",
          order: 2,
          label: "SHORT_NAME",
          visible: true,
        },
        {
          className: "greyText",
          key: "name",
          order: 3,
          label: "LONG_NAME",
          visible: true,
        },
      ],
      filters: [
        {
          type: ConfigurationTableFilterType.Search,
        },
        {
          type: ConfigurationTableFilterType.ResetButton,
        },
      ],
      export: { path: "/api/booking-status-groups-1/export" },
      import: { path: "/api/booking-status-groups-1/presign-url" },
    },
    options: {
      formFields: [
        {
          key: "code",
          label: "CODE",
          type: ConfigurationFormType.Input,
        },
        {
          key: "short_name",
          label: "SHORT_NAME",
          type: ConfigurationFormType.Input,
        },
        {
          key: "name",
          label: "LONG_NAME",
          type: ConfigurationFormType.Input,
        },
      ],
      copyable: false,
      creatable: true,
      createOptions: [
        {
          key: "code",
          flex: "50%",
          required: true,
        },
        {
          key: "short_name",
          flex: "50%",
          required: true,
        },
        {
          key: "name",
          flex: "100%",
          required: true,
        },
      ],
      deletable: true,
      editable: true,
      editOptions: [
        {
          key: "code",
          flex: "50%",
          required: true,
        },
        {
          key: "short_name",
          flex: "50%",
          required: true,
        },
        {
          key: "name",
          flex: "100%",
          required: true,
        },
      ],
    },
  };

export const SURQUAL_BOOKING_STATUS_PAGE: ConfigurationPageTab = {
  type: ConfigurationPageType.TABS,
  count: 0,
  description: "CONF_PAGE_DESC_DEFAULT",
  label: "RESERVATION_STATUS",
  pageLabel: "RESERVATION_STATUS_TITLE_SURQUAL",
  menuLabel: "RESERVATION_STATUS",
  name: "booking_status",
  path: "statut-reservation",
  tabs: [
    SURQUAL_BOOKING_STATUS_PAGE_BOOKING_STATUS_TAB,
    SURQUAL_BOOKING_STATUS_PAGE_BOOKING_STATUS_GROUP_TAB,
  ],
};
